// src/pages/Services/customerService.ts
// Customer accounts created via the client website Sign Up form.
// Mirrors the shape admin/src/admin/pages/customers/customerService.ts reads.
import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../Firebase/Config';

export const CUSTOMERS_COLLECTION = 'customers';

export interface CustomerProfile {
  uid: string;
  fullName: string;
  email: string;
  phone?: string;
  photoURL?: string;
  isActive: boolean;
  createdAt?: any;
  updatedAt?: any;
}

export const createCustomerProfile = async (
  uid: string,
  fullName: string,
  email: string,
  phone?: string
): Promise<void> => {
  await setDoc(doc(db, CUSTOMERS_COLLECTION, uid), {
    fullName,
    email,
    phone: phone || '',
    isActive: true,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
};

export const getCustomerProfile = async (uid: string): Promise<CustomerProfile | null> => {
  const snap = await getDoc(doc(db, CUSTOMERS_COLLECTION, uid));
  if (!snap.exists()) return null;
  const data = snap.data();
  return {
    uid: snap.id,
    fullName: data.fullName || '',
    email: data.email || '',
    phone: data.phone || '',
    photoURL: data.photoURL || '',
    isActive: data.isActive !== false,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
  };
};

export const updateCustomerProfile = async (
  uid: string,
  updates: { fullName?: string; phone?: string; photoURL?: string }
): Promise<void> => {
  await updateDoc(doc(db, CUSTOMERS_COLLECTION, uid), {
    ...updates,
    updatedAt: serverTimestamp(),
  });
};

export const uploadCustomerProfilePhoto = async (uid: string, file: File): Promise<string> => {
  const photoRef = ref(storage, `customerProfiles/${uid}/avatar_${Date.now()}_${file.name}`);
  const snapshot = await uploadBytes(photoRef, file);
  return getDownloadURL(snapshot.ref);
};
